import { Link, useNavigate, useParams } from 'react-router';
import { Page } from '../../components/Layout';
import { QueryView } from '../../components/states';
import { usePlayerStats, useRival } from '../../hooks/queries';
import { useAuth } from '../../stores/auth';
import { PlayerStatsView } from './PlayerStatsView';
import { useT } from '../../i18n';

export function PlayerPage() {
  const { id } = useParams<{ id: string }>();
  const q = usePlayerStats(id!);
  const me = useAuth((s) => s.user?.id);
  const rival = useRival(id!, !!me && me !== id);
  const navigate = useNavigate();
  const t = useT();
  const r = rival.data;
  return (
    <Page>
      <button onClick={() => navigate(-1)} className="mb-2 text-sm font-semibold text-ink-300">
        {t('← Back')}
      </button>
      {r && (r.took || r.lost) ? (
        <Link
          to={`/rivals/${id}`}
          className="mb-3 flex items-center gap-3 rounded-2xl border border-ink-700 bg-ink-850 px-4 py-3 text-sm"
          data-testid="player-head-to-head"
        >
          <span className="text-lg">⚔️</span>
          <span className="min-w-0 flex-1">
            <span className="block font-semibold">{t('You took {a} · They took {b}', { a: r.took, b: r.lost })}</span>
            {r.theyHold ? <span className="block text-xs text-enemy">{t('{n} to retake', { n: r.theyHold })}</span> : null}
          </span>
          <span className="text-ink-500">›</span>
        </Link>
      ) : null}
      <QueryView query={q}>{(s) => <PlayerStatsView stats={s} />}</QueryView>
    </Page>
  );
}
